import * as React from 'react';
import Icons from './assets';

const PlatformIcon: React.FC<IProps> = ({ name }) => {
    return <div
        className="sitegen-platform-button__icon"
        dangerouslySetInnerHTML={{ __html: Icons[name] }}
    />;
};

interface IProps {
    name: string;
}


export default PlatformIcon;
